<template>
  <div>
    <section>
      <el-row type="flex" :gutter="4">
        <el-col :span="4">
          <el-input
              @clear="findAllData"
              clearable
              style="width: 100%"
              placeholder="Nhập số tài khoản"
              v-model="dataSearch.accountNumber"
              @keyup.enter.native="findAllData"
              type="number"
          >
            <template #append>
              <el-button
                  icon="el-icon-search"
                  @click="findAllData"
              ></el-button>
            </template>
          </el-input>
        </el-col>
      </el-row>
    </section>
    <!--      Danh sách bảng-->
    <section style="margin-top: 20px">
      <el-table
          ref="multipleTable"
          :empty-text="tableEmpty"
          v-loading="loading.table"
          :element-loading-text="tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255, 0)"
          highlight-current-row
          :data="dataTable"
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChange"
          :max-height="tableMaxHeight"
          border
      >
<!--        <el-table-column-->
<!--            type="selection"-->
<!--            width="55"-->
<!--            align="center"-->
<!--        />-->

        <el-table-column
            fixed
            type="index"
            label="STT"
            width="50"
            align="center"
        >
        </el-table-column>

        <el-table-column
            fixed
            label="Tên chủ tài khoản"
            align="left"
            prop="accountHolderName"
            width="300"
        >
        </el-table-column>
        <el-table-column
            fixed
            label="Số tài khoản"
            align="left"
            prop="accountNumber"
            width="200"
        >
        </el-table-column>
        <el-table-column
            label="Tên ngân hàng"
            align="left"
            prop="bankName"
            width="300"
        >
        </el-table-column>
        <el-table-column
            label="Tên gợi nhớ"
            align="left"
            prop="label"
            width="200"
        >
        </el-table-column>
        <el-table-column
            label="Tài khoản VA"
            align="center"
            width="200"
        >
          <template v-slot="scope">
            <span
                style="color: #00a1ff; cursor: pointer;"
                @click="handleClickFindListVA(scope.row)"
            >
              {{ scope.row.seAccountVAList.length }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            label="Hiển thị QR"
            align="center"
            prop="showQR"
            width="150"
        >
          <template v-slot="scope">
            <el-checkbox v-model="scope.row.showQR" @change="handleChangeShow(scope.row)" :disabled="!scope.row.bankApiConnected || !scope.row.authenticationOTP"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
            label="Thứ tự ưu tiên"
            align="center"
            prop="priority"
            width="150"
        >
        </el-table-column>
        <el-table-column
            label="Tổng tiền vào trong tháng"
            align="right"
            prop="sumMoneyIn"
            width="200"
        >
          <template v-slot:default="scope">
            {{ scope.row.sumMoneyIn | formatCurrency }}
          </template>
        </el-table-column>
        <el-table-column
            label="Tổng tiền ra trong tháng"
            align="right"
            prop="sumMoneyOut"
            width="200"
        >
          <template v-slot:default="scope">
            {{ scope.row.sumMoneyOut | formatCurrency }}
          </template>
        </el-table-column>
        <el-table-column
            label="Hạn mức nhận vào trong tháng"
            align="center"
            prop="moneyLimit"
            width="200"
        >
          <template v-slot:default="scope">
               <span v-if="scope.row.moneyLimit === 'unlimited'">Không giới hạn</span>
            <span v-else>{{ scope.row.sumMoneyOut | formatCurrency }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="Trạng thái liên kết API"
            align="center"
            prop="bankApiConnected"
            width="200"
        >
          <template v-slot="scope">
            <span v-if="scope.row.bankApiConnected === true" style="color: #09f209"><i
                class="el-icon-circle-check"></i>Đã liên kết</span>
            <span v-if="scope.row.bankApiConnected === false" style="color: #ee4f4f"><i
                class="el-icon-circle-close"></i>Chưa liên kết</span>
          </template>
        </el-table-column>
        <el-table-column
            label="Trạng thái xác thực OTP"
            align="center"
            prop="authenticationOTP"
            width="200"
        >
          <template v-slot="scope">
            <span v-if="scope.row.authenticationOTP === true" style="color: #09f209"><i
                class="el-icon-circle-check"></i>Đã xác thực</span>
            <span v-if="scope.row.authenticationOTP === false" style="color: #ee4f4f"><i
                class="el-icon-circle-close"></i>Chưa xác thực</span>
          </template>
        </el-table-column>
        <el-table-column
            width="400"
            fixed="right"
            label="Tác vụ"
            align="center"
        >
          <template v-slot:default="scope">
            <el-button
                v-if="checkPermission(['bank-connection-manager-update'])"
                size="mini"
                type="success"
                @click="updateAccountBank(scope.row)"
            >Sửa
            </el-button
            >
            <el-button
                size="mini"
                type="warning"
                v-if="checkPermission(['bank-connection-manager-unlink'])"
                :disabled="!scope.row.bankApiConnected"
                :loading="loading.unConnected"
                @click="unConnectedBank(scope.row)"
            >Hủy liên kết
            </el-button
            >
            <el-button
                size="mini"
                v-if="checkPermission(['bank-connection-manager-link'])"
                type="primary"
                :disabled="scope.row.bankApiConnected || scope.row.authenticationOTP"
                @click="connectedBank(scope.row)"
            >Liên kết
            </el-button
            >
            <el-button
                size="mini"
                type="danger"
                v-if="checkPermission(['bank-connection-manager-delete'])"
                :loading="loading.delete"
                :disabled="scope.row.bankApiConnected"
                @click="deleteBank(scope.row)"
            >Xóa
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>

    <el-row type="flex">
      <el-col :span="22" style=" margin: 15px 0">
        <div class="container_nav_page">
          <el-pagination
              background
              layout="prev, pager, next, sizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentPageChange"
              :current-page.sync="dataSearch.page"
              :page-sizes="listSizePage"
              :total="totalPage">
          </el-pagination>
        </div>
      </el-col>
      <el-col :span="2">
        <div style="float: right; margin: 15px 0">
          <el-dropdown @command="handleCommand">
            <el-button class="button-bottom" type="success">
              Tác vụ
              <i class="el-icon-caret-bottom"/>
            </el-button>
            <el-dropdown-menu>
              <el-dropdown-item command="addAccountBank" v-if="checkPermission(['bank-connection-manager-create'])"
              >Thêm tài khoản
              </el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
    <div>
      <AddAccountBankDialog
          :isAddAccountDialog="isAddAccountDialog"
          @closeDialog="closeAddAccountBankDialog"
      />
      <UpdateAccountBankDialog
          :bank="bank"
          :isOpenUpdateAccountBankDialog="isOpenUpdateAccountBankDialog"
          @closeDialog="closeUpdateAccountBankDialog"
      />
      <UnConnectionBanksDialog
          :showUnConnectionBanksDialog = "showUnConnectionBanksDialog"
          :request_id = "request_id"
          :bank = "bank"
          @closeDialog="closeUnConnectionBanksDialog"
      />
      <OTPAuthenticationDialog
          :bank="bank"
          :response="response"
          :isOTPAuthenticationDialog="isOTPAuthenticationDialog"
          @closeDialog="handleCloseOTPAuthenticationDialog"
      />
      <AccountVADialog
          :showQRMainAccount="showQRMainAccount"
          :showAccountVADialog="showAccountVADialog"
          :listVA="listVA"
          :bank="bank"
          :actionToAdmin="actionToAdmin"
          @closeDialog="handleCloseAccountVADialog"
      />
    </div>
  </div>
</template>

<script>


import AddAccountBankDialog from "@/views/sepay/dialog/AddAccountBankDialog.vue";
import UpdateAccountBankDialog from "@/views/sepay/dialog/UpdateAccountBankDialog.vue";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import UnConnectionBanksDialog from "@/views/sepay/dialog/UnConnectionBanksDialog.vue";
import OTPAuthenticationDialog from "@/views/sepay/dialog/OTPAuthenticationDialog.vue";
import AccountVADialog from "@/views/sepay/dialog/AccountVADialog.vue";
import checkPermission from "@/utils/permission";

export default {
  components: {
    AccountVADialog,
    OTPAuthenticationDialog, UnConnectionBanksDialog, UpdateAccountBankDialog, AddAccountBankDialog},

  data() {
    return {
      bank: {},
      listVA: [],
      dataTable: [],
      loading: {
        table: false,
        delete: false,
        unConnected: false,
      },
      request_id: "",
      showUnConnectionBanksDialog:false,
      isAddAccountDialog: false,
      isOpenUpdateAccountBankDialog: false,
      isOTPAuthenticationDialog: false,
      isOTPAuthenticationKienLongBankDialog: false,
      isOTPAuthenticationOCBDialog: false,
      showAccountVADialog: false,
      showQRMainAccount: false,
      response: {},
      dataSearch: {
        accountNumber: "",
        page: 1,
        limit: 10,
      },
      listSizePage: [10, 30, 40, 50, 100],
      totalPage: 0,
      actionToAdmin: false,
    }
  },
  created() {
    this.findAllData()
  },

  computed: {
    tableLoading() {
      return this.$tableLoading;
    },

    tableMaxHeight() {
      return this.$tableMaxHeightCardManager || 1000
    },

    tableEmpty() {
      return this.$tableEmpty
    }
  },

  methods: {
    checkPermission,
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff; font-weight: bold;";
    },

    async findAllData() {
        sePayConnectionService.findAllDataByPlus(this.dataSearch.accountNumber, this.dataSearch.limit, this.dataSearch.page).then((response) => {
          this.dataTable = response.data.data.sePayBankAccountList;
          this.totalPage = response.data.data.total;
        })
    },

    handleSelectionChange(value) {
      this.listBrand = []
      for (let i = 0; i < value.length; i++) {
        this.listBrand.push(value[i].id.toString());
      }
    },

    /**
     * Tác vụ
     */
    handleCommand(command) {
      if (command === "addAccountBank") {
        this.openAddAccountBankDialog()
      }
    },

    /**
     * Hủy liên kết tài khoản
     */
    unConnectedBank(row){
      this.$confirm("Bạn có chắc chắn muốn hủy liên kết tải khoản hay không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        let data = {
          idBankAccount: row.idBankAccount,
          brandName: row.bankName,
          idSchool: row.idSchool,
        }
        this.loading.unConnected = true
        sePayConnectionService.sendRequestDeleteBankAccount(data).then((resp) => {
          if (resp.data.status === 200) {
            if (row.bankName === "ACB" || row.bankName === "VietinBank" || row.bankName === "MBBank") {
              this.request_id = resp.data.data.data.request_id;
              this.bank = row
              this.showUnConnectionBanksDialog = true
            } else if (row.bankName === "KienLongBank" || row.bankName === "OCB") {
              this.showUnConnectionBanksDialog = false
              NotifyMessage.leftCornerNotificationSuccess("Hủy liên kết thành công!")
              this.findAllData()
            }
          } else {
            NotifyMessage.leftCornerNotificationError("Hủy liên kết thất bại!")
            this.findAllData()
          }
        }).catch((err) => {
          console.log(err);
        }).finally(
            this.loading.unConnected = false
        )
      });
    },
    /**
     * Hiển thị QR
     */
    async handleChangeShow(row) {
       await sePayConnectionService.showQRBanks(row.id, row.showQR).then((response) => {
        if (response.data.data === true) {
          NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!")
        }else {
          NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!")
        }
      })
      await this.findAllData();
    },
    /**
     * Xóa tài khoản
     */
    deleteBank(row){
      this.loading.delete = true
      this.$confirm("Bạn có chắc chắn muốn xóa tải khoản hay không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(async () => {
        let data = {
          idBankAccount: row.idBankAccount,
          brandName: row.bankName,
        }
        await sePayConnectionService.forceDeleteBankAccount(data).then((resp) => {
          if (resp.data.data === true) {
            NotifyMessage.leftCornerNotificationSuccess("Xóa tài khoản thành công!")
          } else {
            NotifyMessage.leftCornerNotificationError("Xóa tài khoản thất bại!")
          }
        }).catch((err) => {
          console.log(err);
        }).finally(
            this.loading.delete = false
        )
        await this.findAllData();
        this.loading.delete = false
      });
    },
    /**
     * Liên kết tài khoản
     */
    async connectedBank(row){
      this.$confirm("Bạn có chắc chắn liên kết tải khoản hay không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(async () => {
        let  data = {
          brandName: row.bankName,
          account_holder_name: row.accountHolderName,
          account_number: row.accountNumber,
          identification_number: row.identificationNumber,
          phone_number: row.phoneNumber,
          label: row.label,
        }
        this.bank = data
        await sePayConnectionService.sendRequestCreateBankAccountReload(data).then((resp) => {
          if (resp.data.data.status === 200) {
            if (data.brandName === "ACB" || data.brandName === "VietinBank"|| data.brandName === "MBBank" || data.brandName === "KienLongBank") {
              this.response = resp.data.data;
              this.isOTPAuthenticationDialog = true
            }
          }else {
            NotifyMessage.leftCornerNotificationError("Liên kết thất bại!")
          }
          this.loading.submit = false;
        }).catch((err) => {
          console.log(err);
        }).finally(
            this.loading.submit = false
        )
      });
    },
    /**
     * Hiển thị danh sách tài khoản VA
     */
    handleClickFindListVA(row){
      console.log("check click")
      let checkPermission = this.checkPermission(['bank-connection-manager-va'])
      if (checkPermission === true){
        if (row.bankName !== "OCB" &&  row.bankName !== "KienLongBank") {
          this.$notify.error({
            title: "Thông báo",
            message: "Tính năng này chưa được ngân hàng hỗ trợ!",
          });
        } else {
          this.showQRMainAccount = row.showQR
          this.bank = row
          this.listVA = row.seAccountVAList
          this.showAccountVADialog = true
        }
      }else {
        this.$notify.error({
          title: "Thông báo",
          message: "Bạn không có quyền truy cập!",
        });
      }
    },
    /**
     * Phân trang
     */
    handleSizeChange(value) {
      this.dataFilter.limit = value;
      this.findAllData();
    },
    handleCurrentPageChange(value) {
      this.dataFilter.page = value;
      this.findAllData();
    },
    /**
     * Mở dialog
     */
    openAddAccountBankDialog() {
        this.isAddAccountDialog = true;
    },
    updateAccountBank(row){
      this.bank = row;
      this.isOpenUpdateAccountBankDialog = true;
    },

    /**
     * Đóng dialog
     */
    closeAddAccountBankDialog (){
      this.isAddAccountDialog = false;
      this.findAllData();
    },
    closeUpdateAccountBankDialog(){
      this.isOpenUpdateAccountBankDialog = false;
      this.findAllData();
    },
    closeUnConnectionBanksDialog(){
      this.showUnConnectionBanksDialog = false;
      this.findAllData();
    },
    handleCloseOTPAuthenticationDialog(){
      this.isOTPAuthenticationDialog = false
      this.findAllData();
    },
    handleCloseAccountVADialog(){
      this.showAccountVADialog = false;
      this.findAllData();
    }

  }
}
</script>

<style lang="scss" scoped>
.menu_task_form {
  display: contents;
}

.container_task {
  display: flex;
  justify-content: right;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}

.sub_menu {
  /deep/ .el-submenu__title {
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 4px;
  }

  /deep/ i {
    color: #FFFFFF;
    margin-top: 0 !important;
  }
}

.name_device {
  cursor: pointer;

  &:hover {
    color: #00a1ff;
  }
}

.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}
</style>